import { usePage } from "@inertiajs/react";

/** The session's user (or null) and the admin behind an impersonation. */
export function useAuth() {
  return usePage().props.auth;
}

/**
 * Whether the Refuge is showing a warning about the account itself (a ban,
 * or HCA rejecting the identity), so the Refuge tab can flag it from
 * anywhere in the book.
 */
export function useAccountWarning(): boolean {
  const { user } = useAuth();
  return !!user && (user.banned || user.verification.status === "ineligible");
}
